import { AppState } from 'services/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
// @ts-ignore
import { selectCurrentSeasonIsComplete } from 'services/currentSeasonId/selectors';
import { ActiveSeasonAlertState } from './types';

const selectActiveSeasonAlert = (state: AppState): ActiveSeasonAlertState =>
    state.activeSeasonAlert;

const selectActiveSeasonAlertIgnore = createDeepEqualSelector(
    selectActiveSeasonAlert,
    (activeSeasonAlertState) => activeSeasonAlertState.ignore
);

const selectActiveSeasonAlertVisible = createDeepEqualSelector(
    selectActiveSeasonAlertIgnore,
    selectCurrentSeasonIsComplete,
    (activeSeasonAlertIgnore, currentSeasonIsComplete) =>
        Boolean(!activeSeasonAlertIgnore && currentSeasonIsComplete)
);

export {
    selectActiveSeasonAlert,
    selectActiveSeasonAlertIgnore,
    selectActiveSeasonAlertVisible
};
